import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Assisteur, Garantie, Programme } from "../../services/Api/swagger";

export interface ProgrammeState {
  infoAssisteur?: Assisteur[];
  listeProgramme?: (Programme | undefined)[];
  selectedProgramme?: Programme;
  listeGarantiesSelectedProgramme?: Garantie[];
}

const initialState: ProgrammeState = {
  infoAssisteur: undefined,
};

export const ProgrammeSlice = createSlice({
  name: "@@app/programme",
  initialState: initialState,
  reducers: {
    setAssisteur: (
      state: ProgrammeState,
      action: PayloadAction<Assisteur | undefined>
    ) => {
      if (action.payload) {
        state.infoAssisteur = state.infoAssisteur
          ? [...state.infoAssisteur, action.payload]
          : [action.payload];
      } else {
        state.infoAssisteur = undefined;
      }
    },
    setListeprogramme: (
      state: ProgrammeState,
      action: PayloadAction<Programme | undefined>
    ) => {
      if (action.payload) {
        state.listeProgramme = state.listeProgramme
          ? [...state.listeProgramme, action.payload]
          : [action.payload];
      } else {
        state.listeProgramme = undefined;
      }
    },
    setSelectedProgramme: (
      state: ProgrammeState,
      action: PayloadAction<Programme | undefined>
    ) => {
      state.selectedProgramme = action.payload;
    },
    setListeGarantiesSelectedProgramme: (
      state: ProgrammeState,
      action: PayloadAction<Garantie[] | undefined>
    ) => {
      state.listeGarantiesSelectedProgramme = action.payload;
    },
  },
});

export const {
  setAssisteur,
  setListeprogramme,
  setListeGarantiesSelectedProgramme,
  setSelectedProgramme,
} = ProgrammeSlice.actions;

// Selectors
export const getAssisteur = (state): Assisteur[] | undefined =>
  state.programme && state.programme.infoAssisteur;

export const getListeProgramme = (state): Programme[] | undefined =>
  state.programme.listeProgramme && state.programme.listeProgramme;

export const getSelectedProgramme = (state): Programme | undefined =>
  state.programme.selectedProgramme && state.programme.selectedProgramme;

export const getListeGarantiesSelectedProgramme = (
  state
): Garantie[] | undefined =>
  state.programme.listeGarantiesSelectedProgramme &&
  state.programme.listeGarantiesSelectedProgramme;
